function carouselInit() {
    let carousel = document.querySelector("#testimonial-carousel");
    if (carousel) {
        let intervalAmount = parseInt(carousel.dataset.interval);
        /* Initialize Carousel */
        var paused = 0;
        $("#testimonial-carousel #myCarousel").carousel({
            interval: intervalAmount,
            pause: 0
        });
        /* Play trigger */
        $("#testimonial-carousel #toggleCarousel")
            .off("click")
            .on("click", function() {
                var state = paused ? "cycle" : "pause";
                paused = paused ? 0 : 1;
                $("#testimonial-carousel #myCarousel").carousel(state);
                $(this)
                    .find("i")
                    .toggleClass("fa-play fa-pause");
            });
    }

    function initCarouselAriaCurrent() {
        // Find all carousels on the page
        const carousels = document.querySelectorAll('.carousel');
        
        carousels.forEach(carousel => {
            const indicators = carousel.querySelectorAll('.carousel-indicators li');
            
            if (indicators.length > 0) {
                // Set initial aria-current on active indicator
                updateAriaCurrentOnIndicators(indicators);
                
                // Listen for Bootstrap carousel slide events
                $(carousel).on('slid.bs.carousel', () => {
                    updateAriaCurrentOnIndicators(indicators);
                });
            }
        });
    }
    
    function updateAriaCurrentOnIndicators(indicators) {
        indicators.forEach(indicator => {
            if (indicator.classList.contains('active')) {
                indicator.setAttribute('aria-current', 'true');
            } else {
                indicator.removeAttribute('aria-current');
            }
        });
    }

    // Initialize carousel aria-current functionality
    initCarouselAriaCurrent();
}

export default carouselInit;
